import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-ink px-5 py-12 text-bone md:px-12 md:py-32"
    >
      <div className="mx-auto max-w-[1600px]">
        <div className="mb-12 flex flex-wrap items-start justify-between gap-10 md:mb-20">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-bone/60">
              Easy Mood — Clever Goods
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-bone/60">
              Portable products and home conveniences, tested daily. Everyday
              things, made clever.
            </p>
          </div>
          <div className="flex gap-16 text-xs uppercase tracking-[0.2em]">
            <div className="flex flex-col gap-3">
              <span className="text-bone/40">Explore</span>
              <a data-testid="footer-link-shop" href="#shop" className="transition-colors duration-300 hover:text-ember">Shop</a>
              <a data-testid="footer-link-manifesto" href="#manifesto" className="transition-colors duration-300 hover:text-ember">Manifesto</a>
            </div>
            <div className="flex flex-col gap-3">
              <span className="text-bone/40">Help</span>
              <a
                data-testid="footer-link-orders"
                href="https://f8e6ab-3.myshopify.com/account/orders"
                target="_blank"
                rel="noreferrer"
                className="transition-colors duration-300 hover:text-ember"
              >
                My Orders
              </a>
              <a
                data-testid="footer-link-returns"
                href="https://f8e6ab-3.myshopify.com/policies/refund-policy"
                target="_blank"
                rel="noreferrer"
                className="transition-colors duration-300 hover:text-ember"
              >
                Return Policy
              </a>
            </div>
          </div>
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1.2, ease: EASE }}
          data-testid="footer-wordmark"
          className="whitespace-nowrap font-serif text-[14vw] font-medium leading-[0.85] tracking-tighter transition-colors duration-700 hover:text-ember sm:text-[15.5vw]"
        >
          EASY MOOD
        </motion.h2>

        <div className="mt-10 flex flex-col items-start gap-2 border-t border-bone/15 pt-6 text-[10px] uppercase tracking-[0.18em] text-bone/50 sm:flex-row sm:items-center sm:justify-between sm:text-[11px]">
          <span>© 2026 Easy Mood</span>
          <span>Everyday things, made clever</span>
        </div>
      </div>
    </footer>
  );
}
